const api = '/business'
export default {
  // 游客服务
  // 预约管理
  // 预约项目
  selectAppointConfig: api + '/appointConfig/selectAppointConfig',
  updateAppointConfig: api + '/appointConfig/updateAppointConfig',
  selectAppointItemByItemId: api + '/appointItem/selectAppointItemByItemId',
  // 分页查询
  selectAppointItemByPage: api + '/appointItem/selectAppointItemByPage',
  insertAppointItem: api + '/appointItem/insertAppointItem',
  updateAppointItemStatus: api + '/appointItem/updateAppointItemStatus',
  deleteAppointItem: api + '/appointItem/deleteAppointItem',
  selectParkAppointItemList: api + '/appointItem/selectParkAppointItemList',
  // 预约项目时间段
  selectAppointItemTimeList: api + '/appointItemTime/selectAppointItemTimeList',
  // 预约项目列表
  selectAppointItemList: api + '/appointItem/selectAppointItemList',
  // 所有预约项目
  selectParkAppointItemList: api + '/appointItem/selectParkAppointItemList',

  // 游客
  insertTouristInfo: api + '/touristInfo/insertTouristInfo',
  deleteTouristInfo: api + '/touristInfo/deleteTouristInfo',
  updateTouristInfo: api + '/touristInfo/updateTouristInfo',
  selectTouristInfoByList: api + '/touristInfo/selectTouristInfoByList',
  selectTouristInfoByPage: api + '/touristInfo/selectTouristInfoByPage',
  insertAppointItemRecord: api + '/appointItemRecord/insertAppointItemRecord',
  // 取消预约
  updateAppointItemRecordStatus: api + '/appointItemRecord/updateAppointItemRecordStatus',
  // 我的预约
  selectMyPage: api + '/appointItemRecord/selectMyPage',
  // 预约记录详情
  selectAppointItemRecordByRecordId: api + '/appointItemRecord/selectAppointItemRecordByRecordId',
  // 预约记录列表
  selectAppointItemRecordByPage: api + '/appointItemRecord/selectAppointItemRecordByPage',
  // 预约人数总和
  selectEnterNumTotal: api + '/appointItemRecord/selectEnterNumTotal',
  // 入园游客信息
  selectTouristAppointItem: api + '/appointItemRecord/selectTouristAppointItem',

  // 景观景点
  insertScenery: api + '/scenery/insertScenery',
  updateScenery: api + '/scenery/updateScenery',
  deleteScenery: api + '/scenery/deleteScenery',
  selectSceneryBySceneryId: api + '/scenery/selectSceneryBySceneryId',
  selectSceneryByPage: api + '/scenery/selectSceneryByPage',
  selectSceneryByList: api + '/scenery/selectSceneryByList',

  // 园内服务
  insertServiceFacilities: api + '/serviceFacilities/insertServiceFacilities',
  updateServiceFacilities: api + '/serviceFacilities/updateServiceFacilities',
  deleteServiceFacilities: api + '/serviceFacilities/deleteServiceFacilities',
  selectServiceFacilitiesByServiceId: api + '/serviceFacilities/selectServiceFacilitiesByServiceId',
  selectServiceFacilitiesByPage: api + '/serviceFacilities/selectServiceFacilitiesByPage',

  // 园内服务-服务类型
  insertServiceType: api + '/serviceType/insertServiceType',
  updateServiceType: api + '/serviceType/updateServiceType',
  deleteServiceType: api + '/serviceType/deleteServiceType',
  selectServiceTypeByList: api + '/serviceType/selectServiceTypeByList',

  // 主题活动
  insertTopicActivities: api + '/topicActivities/insertTopicActivities',
  updateTopicActivities: api + '/topicActivities/updateTopicActivities',
  deleteTopicActivities: api + '/topicActivities/deleteTopicActivities',
  selectTopicActivitiesById: api + '/topicActivities/selectTopicActivitiesById',
  selectTopicActivitiesByPage: api + '/topicActivities/selectTopicActivitiesByPage',

  // 失物招领
  insertLostAndFound: api + '/lostAndFound/insertLostAndFound',
  updateLostAndFound: api + '/lostAndFound/updateLostAndFound',
  deleteLostAndFound: api + '/lostAndFound/deleteLostAndFound',
  selectLostAndFoundById: api + '/lostAndFound/selectLostAndFoundById',
  selectLostAndFoundByPage: api + '/lostAndFound/selectLostAndFoundByPage',
  insertLostItemType: api + '/lostItemType/insertLostItemType',
  deleteLostItemType: api + '/lostItemType/deleteLostItemType',
  selectAllLostItemType: api + '/lostItemType/selectAllLostItemType',
  updateLostItemType: api + '/lostItemType/updateLostItemType',

  // 客服管理
  insertKfAnswer: api + '/kfAnswer/insertKfAnswer',
  updateKfAnswer: api + '/kfAnswer/updateKfAnswer',
  deleteKfAnswer: api + '/kfAnswer/deleteKfAnswer',
  selectKfAnswerById: api + '/kfAnswer/selectKfAnswerById',
  selectKfAnswerByPage: api + '/kfAnswer/selectKfAnswerByPage',
  insertKfPhone: api + '/kfPhone/insertKfPhone',
  updateKfPhone: api + '/kfPhone/updateKfPhone',
  selectKfPhoneByPage: api + '/kfPhone/selectKfPhoneByPage',
  deleteKfPhone: api + '/kfPhone/deleteKfPhone',

  // 游客评价
  selectTouristEvaluateByPage: api + '/touristEvaluate/selectTouristEvaluateByPage',
  selectTouristEvaluateSumByPage: api + '/touristEvaluate/selectTouristEvaluateSumByPage',
  selectSourceList: api + '/touristEvaluate/selectSourceList',
  shield: api + '/touristEvaluate/shield',
  top: api + '/touristEvaluate/top',
  batchShield: api + '/touristEvaluate/batchShield',
  deleteDataTouristEvaluate: api + '/touristEvaluate/deleteDataTouristEvaluate',

  // 公告发布
  insertNotice: api + '/notice/insertNotice',
  updateNotice: api + '/notice/updateNotice',
  deleteNotice: api + '/notice/deleteNotice',
  sendNotice: api + '/notice/sendNotice',
  selectNoticeByNoticeId: api + '/notice/selectNoticeByNoticeId',
  selectNoticeByPage: api + '/notice/selectNoticeByPage',

  // 问卷调查
  insertQuestionnaire: api + '/questionnaireSurvey/insertQuestionnaire',
  publishQuestionnaireById: api + '/questionnaireSurvey/publishQuestionnaireById',
  questionnaireSurvey: api + '/questionnaireSurvey/updateQuestionnaire',
  updateQuestionnaire: api + '/questionnaireSurvey/updateQuestionnaire',
  deleteQuestionnaire: api + '/questionnaireSurvey/deleteQuestionnaire',
  selectQuestionnaireByPage: api + '/questionnaireSurvey/selectQuestionnaireByPage',
  selectQuestionDetail: api + '/questionnaireSurvey/selectQuestionDetail',
  selectQuestionnaireDetail: api + '/questionnaireSurvey/selectQuestionnaireDetail',
  selectGapFillingQuestionByPage: api + '/questionnaireSurvey/selectGapFillingQuestionByPage',
  selectMydQuestionnaireResult:  api + '/questionnaireSurvey/selectMydQuestionnaireResult',

  exportMydQuestionnaireStatistic: '/business/questionnaireSurvey/exportMydQuestionnaireStatistic',
  exportMydQuestionnaireResult: '/business/questionnaireSurvey/exportMydQuestionnaireResult',

  // 投诉反馈
  selectAppUserFeedbackByPage: api +'/appUserFeedback/selectAppUserFeedbackByPage',
  selectAppUserFeedbackByFeedbackId:  api + '/appUserFeedback/selectAppUserFeedbackByFeedbackId',
  deleteAppUserFeedback: api + '/appUserFeedback/deleteAppUserFeedback',
  updateAppUserFeedback:  api + '/appUserFeedback/updateAppUserFeedback',

  // 游览路线
  selectAllTouringRoute:  api + '/parkTouringRoute/selectAllTouringRoute',
  addTouringRoute:  api + '/parkTouringRoute/addTouringRoute',
  updateTouringRoute: api +  '/parkTouringRoute/updateTouringRoute',
  deleteTouringRoute: api +  '/parkTouringRoute/deleteTouringRoute'
}
